module.exports = __webpack_public_path__ + "static/media/accident-default-image1.5256f48b.png";